import React from 'react';
import { useTranslation } from 'react-i18next';
import { File, Tag } from 'lucide-react';

import { useCountCategories, useCountFiles } from '@/api/generated';
import MetricCard from '@/routes/(app)/agents/components/metric-card';
import MetricSkeleton from '@/routes/(app)/agents/components/metric-skeleton';

const DataMetrics = () => {
  const { t } = useTranslation();
  const { data: countFiles, isLoading: isLoadingFiles } = useCountFiles();
  const { data: countCategories, isLoading: isLoadingCategories } =
    useCountCategories();

  return (
    <div className='grid grid-cols-3 gap-4'>
      {isLoadingFiles ? (
        <MetricSkeleton />
      ) : (
        <MetricCard
          icon={<File />}
          title={t('dataAgent.metrics.files')}
          metric={countFiles?.count}
        />
      )}
      {isLoadingCategories ? (
        <MetricSkeleton />
      ) : (
        <MetricCard
          icon={<Tag />}
          title={t('dataAgent.metrics.categories')}
          metric={countCategories?.count}
        />
      )}
    </div>
  );
};

export default DataMetrics;
